const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
// 80 random bits, ASCII only, with a fixed event prefix: 17 keystrokes total.
export function createShortCode() {
  const bytes = crypto.getRandomValues(new Uint8Array(10));
  let value = 0, bits = 0, code = "P";
  for (const byte of bytes) {
    value = (value << 8) | byte;
    bits += 8;
    while (bits >= 5) { bits -= 5; code += alphabet[(value >>> bits) & 31]; }
  }
  return code;
}
export function normalizeShortCode(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const code = value.trim().toUpperCase();
  return /^P[A-Z2-7]{16}$/.test(code) ? code : null;
}
export const OFFLINE_DATABASE_VERSION = 2;
